import { useEffect, useState } from "react";
import { Button, Grid, Card } from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import BusinessIcon from '@mui/icons-material/Business';
import MDAvatar from "components/MDAvatar";
import burceMars from "assets/images/dummy-logo.png";
import { useNavigate } from "react-router-dom";
import { setYojnaId } from "app/yojnaIdManagementSlice";

function Projects() {
  const [departments, setDepartments] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchYojnaDepartment = async () => {
      const access_token =
        localStorage.getItem("access_token") || sessionStorage.getItem("access_token");
      const user_role = localStorage.getItem("user_role") || sessionStorage.getItem("user_role");

      if (!access_token || !user_role) {
        console.error("❌ Access token or Role ID missing!");
        return;
      }

      try {
        const response = await axios.get(
          `https://telelawmh.in/apiv2collectorapp/public/api/yojna-department`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
              "Content-Type": "application/json",
              RoleID: user_role,
            },
          }
        );

        console.log("✅ API Response:", response.data.departments);
        setDepartments(response.data.departments); // ✅ Store data in state
      } catch (error) {
        console.error("❌ API Error:", error.response ? error.response.data : error.message);
      }
    };

    fetchYojnaDepartment();
  }, []);
  
  const renderToSubyojnaPage = (yojna_department_id) => {
    console.log("hello key")
    dispatch(setYojnaId(yojna_department_id));
    // alert("helolo");
    console.log("yojna_department_id", yojna_department_id);
    navigate("/subyojana");
  };
  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3} pb={0}>
        {/* <MDTypography variant="h3" gutterBottom>
          <BusinessIcon /> विभाग
        </MDTypography> */}
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <MDTypography variant="h2" fontWeight="medium">
              विभाग
            </MDTypography>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox sx={{ flexGrow: 1, padding: 2 }}>
        <Grid container spacing={2}>
          {departments.map((dept, index) => (
            <Grid item xs={12} md={4} key={index}> {/* ✅ xs=12 for mobile, md=4 for larger screens */}
              <Button
                variant="contained"
                fullWidth
                sx={{
                  my: 1,
                  py: 3,
                  fontSize: "1.2rem",
                  color: "#dddddd",
                  background: "linear-gradient(135deg, #1e3c72 10%, #2a5298 100%)",
                  transition: "all 0.3s ease-in-out",
                  "&:hover": {
                    background: "linear-gradient(135deg, #2a5298 10%, #1e3c72 100%)",
                  },
                }}
                onClick={() => renderToSubyojnaPage(dept.yojna_department_id)}

              >
                {dept.yojna_department_title}
              </Button>
            </Grid>
          ))}
        </Grid>
      </MDBox>

    </Card>
  );
}

export default Projects;
